module.exports = __webpack_public_path__ + "static/media/bitmap.4751e3d9.png";